import React from 'react';
import { fetchReportDauMau } from '../../../cores/api/api-dashboard';
import { useQuery } from '@tanstack/react-query';
import CardTotal from '../../components/card-total';
import IconLineUp from '../../../icons/icon-line-up';
import { formatCountNumber } from '../../../utils/format-data';
export default function SectionDauMauCard() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const _useQuery = useQuery({
        queryKey: ['fetchReportDauMau', new Date().getFullYear()],
        queryFn: () => fetchReportDauMau(),
        enabled: true,
        suspense: true
    }), data = _useQuery.data;
    return /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-4 gap-6"
    }, /*#__PURE__*/ React.createElement(CardTotal, {
        title: "DAU",
        total: `${formatCountNumber((_a = data === null || data === void 0 ? void 0 : data.dau.today) !== null && _a !== void 0 ? _a : 0)} ユーザー`,
        growthTitle: ((_b = data === null || data === void 0 ? void 0 : data.dau.growth) !== null && _b !== void 0 ? _b : 0) >= 0 ? 'アップ' : '下がる',
        isDown: ((_c = data === null || data === void 0 ? void 0 : data.dau.growth) !== null && _c !== void 0 ? _c : 0) < 0,
        change_percent: (_d = data === null || data === void 0 ? void 0 : data.dau.growth) !== null && _d !== void 0 ? _d : 0,
        icon: /*#__PURE__*/ React.createElement(IconLineUp, null)
    }), /*#__PURE__*/ React.createElement(CardTotal, {
        title: "MAU",
        total: `${formatCountNumber((_e = data === null || data === void 0 ? void 0 : data.mau.current_month) !== null && _e !== void 0 ? _e : 0)} ユーザー`,
        growthTitle: ((_f = data === null || data === void 0 ? void 0 : data.mau.growth) !== null && _f !== void 0 ? _f : 0) >= 0 ? 'アップ' : '下がる',
        isDown: ((_g = data === null || data === void 0 ? void 0 : data.mau.growth) !== null && _g !== void 0 ? _g : 0) < 0,
        change_percent: (_h = data === null || data === void 0 ? void 0 : data.mau.growth) !== null && _h !== void 0 ? _h : 0,
        icon: /*#__PURE__*/ React.createElement(IconLineUp, null)
    }));
}
